import type { SiteConfigFn } from '@wix/thunderbolt-vsm-api-types'

const accessibilitySiteConfig: SiteConfigFn<Record<string, never>> = () => {
	return {
		shouldLoadSiteFeature: false,
		shouldLoadSiteConfig: false,
		siteConfig: null,
	}
}

const name = 'accessibility'

export const config = { site: accessibilitySiteConfig, name }
